import React, { FC } from "react";
import { Popover } from "antd";
import { ICategorization } from "../../../configMap/interfaces/category";
import useLinkIcon from "../../hooks/useLinkIcon";
import "./LinkIcon.scss";

type Props = {
  categorization: ICategorization;
};

const LinkIcon: FC<Props> = ({ categorization }) => {
  const { direction, header, detail, tagLabel, tagValues, pillLabel } =
    useLinkIcon(categorization);

  if (!direction) {
    return null;
  }

  return (
    <Popover
      trigger="hover"
      mouseEnterDelay={0.5}
      placement="bottom"
      overlayClassName="link-popover-overlay"
      content={
        <div className="link-popover">
          <div className="link-popover__header">{header}</div>
          <div className="link-popover__detail">{detail}</div>
          <div className={`link-relation link-relation--${direction}`}>
            <span className="link-relation__label">{tagLabel}</span>
            <div className="link-relation__chips">
              {tagValues.map((value, index) => (
                <span className="link-relation__chip" key={index}>
                  {value}
                </span>
              ))}
            </div>
          </div>
        </div>
      }
    >
      <span
        className="link-pill bi bi-diagram-3"
        role="img"
        aria-label={pillLabel}
        onClick={(event) => event.stopPropagation()}
      />
    </Popover>
  );
};

export default LinkIcon;
